import { render, staticRenderFns } from "./AcquisitionBoosterDashboard.vue?vue&type=template&id=b3c0c122&scoped=true&"
import script from "./AcquisitionBoosterDashboard.vue?vue&type=script&lang=js&"
export * from "./AcquisitionBoosterDashboard.vue?vue&type=script&lang=js&"
import style0 from "./AcquisitionBoosterDashboard.vue?vue&type=style&index=0&id=b3c0c122&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3c0c122",
  null
  
)

export default component.exports